import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { getItemTagsData } from "../services/articles.service";
import { QueryKeys } from "./queryKeys";

type ItemTagsByItemNo = Record<string, string[]>;

export const useItemTagsByItemNos = (
  itemNos: string | undefined
): UseQueryResult<ItemTagsByItemNo> => {
  return useQuery<ItemTagsByItemNo, Error>({
    queryKey: [QueryKeys.ItemTagsByItemNo, itemNos],
    queryFn: async () => {
      const itemTags = await getItemTagsData(itemNos || "");

      return itemTags.reduce<ItemTagsByItemNo>((itemTagsByItemNo, item) => {
        itemTagsByItemNo[item.itemNo] = Array.from(
          new Set([
            ...(itemTagsByItemNo[item.itemNo] ?? []),
            ...(item.tags ?? []),
          ])
        );
        return itemTagsByItemNo;
      }, {});
    },
    enabled: !!itemNos,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours cache time
    staleTime: 1000 * 60 * 60 * 24, // 24 hours stale time
  });
};
